/**
 * prevetDefault + stopPropagation
 * @param  {Event} event
 * @returns {Function}
 */
export var eventStopper = function eventStopper(callback, scope) {
    return function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (scope) {
            return callback.call(scope, event);
        }

        callback(event);
    };
};